import script from "./SuccessResultBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessResultBox.vue?vue&type=script&setup=true&lang=js"

import "./SuccessResultBox.vue?vue&type=style&index=0&id=c780acca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c780acca"]])

export default __exports__